import { FormikForm } from '../../Formik'

import { FormFields } from './FormFields'

function RadioGroupModalForm({
  formFieldsProps,
  initialValues,
  onCancel,
  onSubmit,
}) {
  return (
    <FormikForm
      initialValues={initialValues}
      validationOnBlur={false}
      onSubmit={onSubmit}
    >
      <FormFields {...formFieldsProps} onCancel={onCancel} />
    </FormikForm>
  )
}

export default RadioGroupModalForm
